import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import {
  AddOneOrderAction,
  AddPharmcyInCartFromListAction,
  DeleteOrderWithErrorsAction,
  DeletePharmcyInCartFromListAction,
  DeleteToTopInListPharmaciesAction,
  PopupOnePharmcyForActivaMarkerInCartAction,
  RunEffectDeletePharmcyInCartFromListAction,
  SelectedCartMarkerAction,
  SetCenterMapAction,
  SetZoomMapAction,
  SwitchInfoOnePharmcyAction,
  ToggleProductsListInPharmacyPopupAction,
  UpdateCartMarkerAction
} from '../../../store/actions';
import { AppState } from '@appStates';
import { LocalStorageService, ScreenDetectedService } from '@core/services';
import { BtnTypeColor, ListLazyComponents, TypeProduct } from '@enums';
import { BzApteka, BzProduct, IReserveOrder, IUserOrder } from '@interfaces';
import { select, Store } from '@ngrx/store';
import { selectErrorsOrder } from '../../../store/selectors';
import { take } from 'rxjs/operators';
import { OrdersApiService } from 'src/app/core/services/api.services/orders-api.service';
import { CartLocalStorageService } from '../../../core/services/storage.services/cart-local-storage.service';
import { ScrollPositionLocalStorageService } from 'src/app/core/services/storage.services/scroll-position-local-storage.service';
import { ApplicationRoutingService } from '@application-routing';
import { Router } from '@angular/router';
import { AsyncCallback } from '../../../shared/decorators';

@Component({
  selector: 'bz-apteka',
  templateUrl: './bz-apteka.component.html',
  styleUrls: ['./bz-apteka.component.sass']
})
export class BzAptekaComponent implements OnInit, OnChanges {
  @Input() public isArchive = false;
  @Input() public isCart = false;
  @Input() public isListInfo = false;
  @Input() public isOrder = false;
  @Input() public isCurrentOrder = false;
  @Input() public isPharmaciesPage = false;
  @Input() public isPopUp = false;
  @Input() public apteka: BzApteka;
  @Input() public isPopup = false;

  @Output() public onDeleteOrder: EventEmitter<BzApteka> = new EventEmitter();
  @Output() public emmitContainer: EventEmitter<any> = new EventEmitter();
  @Output() public onToCart: EventEmitter<any> = new EventEmitter();
  @Output() public switchToMobileFromMap: EventEmitter<number> = new EventEmitter();

  public typeProduct = TypeProduct;
  public totalProductsSum: number;
  public totalProductsOldSum: number;
  public totalEconomySum: number;
  public colors: typeof BtnTypeColor = BtnTypeColor;

  trackById = (_: unknown, item: BzProduct) => item.id;

  constructor(
    private readonly screen: ScreenDetectedService,
    private readonly cartLS: CartLocalStorageService,
    private readonly ordersApiService: OrdersApiService,
    private readonly localStorageService: LocalStorageService,
    private readonly store: Store<AppState>,
    private readonly scrollPositionService: ScrollPositionLocalStorageService,
    private readonly routingService: ApplicationRoutingService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.getSum();
  }

  ngOnChanges(): void {
    this.getSum();
  }

  public swithIsListInfo(): void {
    if (!this.isPopup && !this.isCart && !this.isOrder) {
      this.store.dispatch(SwitchInfoOnePharmcyAction(
        { id: this.apteka.id, value: !this.apteka.isOpenInfo }
      ));
    }
    if (this.isCart || this.isOrder || this.isPopUp) {
      this.isListInfo = !this.isListInfo;
    }
    if (this.isPopUp) {
      this.store.dispatch(ToggleProductsListInPharmacyPopupAction({ value: this.isListInfo }));
    }
  }

  public getSum(): void {
    this.totalProductsSum = this.apteka.prices?.withDiscount ?? 0;
    this.totalEconomySum = this.apteka.prices?.discount ?? 0;
    this.totalProductsOldSum = this.apteka.prices?.outDiscount ?? 0;
  }

  public onToOrderPharmcy(apteka: BzApteka): void {
    if (this.apteka.isCartCurrent) {
      this.localStorageService.deleteCurrentOrderFromCart(apteka.id, new Set(apteka.products.map(el => el.id)));
      this.store.dispatch(RunEffectDeletePharmcyInCartFromListAction({ pharmcy: apteka }));
      this.updateMap(apteka.id, false);
      const cartState: BzApteka[] = JSON.parse(this.cartLS.cart);
      const idsCartState: Set<number> = new Set(cartState.map((data: BzApteka): number => data.id));
      if (!idsCartState.has(apteka.id)) {
        this.store.dispatch(DeleteToTopInListPharmaciesAction({ id: apteka.id }));
      }
    } else {
      this.localStorageService.addToCart(apteka);
      this.store.dispatch(AddPharmcyInCartFromListAction({ pharmcyId: apteka.id }));
      this.updateMap(apteka.id, true, [apteka.latitude, apteka.longitude]);
    }

    if (this.isPopup) {
      this.store.dispatch(PopupOnePharmcyForActivaMarkerInCartAction());
    }
  }

  public deleteFromDB(apteka: BzApteka): void {
    this.onDeleteOrder.emit(apteka);
    this.store.dispatch(DeletePharmcyInCartFromListAction({ pharmcy: apteka }));
    this.store.dispatch(UpdateCartMarkerAction({ markerID: apteka.id, value: false }));
  }

  public cancelOrderChanges(): void {
    this.localStorageService.deleteOneOrderFromDb(this.apteka);
    if (this.apteka.order.id === null) {
      this.store.dispatch(DeleteOrderWithErrorsAction({ id: this.apteka.id }));
    } else {
      this.ordersApiService.cancelOrder(this.apteka);
    }
  }

  public confirmOrderChanges(): void {
    const order: BzApteka[] = [];
    const user: IUserOrder = { phone: this.apteka.order.customerPhone };
    // если юзверь подтверждает изменения в момент когда id заказа еще нет (заказ не записан)
    if (this.apteka.order.id == null) {

      this.store.pipe(
        select(selectErrorsOrder),
        take(1)
      ).subscribe((pharmacies: BzApteka[]) => {
        pharmacies.forEach((apteka: BzApteka) => {
          // tslint:disable-next-line:triple-equals
          if (apteka.id == this.apteka.id) {
            const newModel: BzApteka = Object.assign({}, { ...apteka, products: [] });
            apteka.products.forEach((product: BzProduct) => {
              const newProduct: BzProduct = Object.assign({}, { ...product, qty: product.orderedContentNum });
              newModel.products.push(newProduct);
            });
            order.push(newModel);
          }
        });
      });

      this.ordersApiService.reserveOrder(order, user).subscribe((response: IReserveOrder) => {
        this.store.dispatch(DeleteOrderWithErrorsAction({ id: this.apteka.id }));
        this.localStorageService.deleteOneOrderFromDb(this.apteka);
        const result: BzApteka[] = response.success.concat(response.error);
        if (result[0].order.id !== null) {
          this.localStorageService.setOrderIdToHistory(result[0].order.id);
          this.localStorageService.clearCart();
          this.store.dispatch((AddOneOrderAction({ apteka: result[0] })));
        } else {
          this.localStorageService.setOrderToDb(result[0]);
        }
      });

      // если юзверь подтверждает изменения в момент когда id уже есть (заказ записан)
    } else {
      this.ordersApiService.updateOrder(this.apteka);
    }
  }

  public showConfirmPopup(): void {
    this.onDeleteOrder.emit(this.apteka);
  }

  public onEmmitContainer(): void {
    this.emmitContainer.next(null);
  }

  public openCart(): void {
    if (this.screen.isMobile()) {
      setTimeout(() => this.scrollPositionService.scrollPosition = '0', 50);
    }
    this.routingService.navigate(ListLazyComponents.cart, this.router.routerState.snapshot.url);
  }

  public toCurrentMap(coord: number[], sw = true, id: number): void {
    this.store.dispatch(SetCenterMapAction({ center: coord }));
    this.store.dispatch(SetZoomMapAction({ zoom: 19 }));

    if (!this.screen.isMobile()) { this.store.dispatch(SelectedCartMarkerAction({ id })); }

    if (this.screen.isMobile() && sw) {
      this.switchToMobileFromMap.emit(id);
      setTimeout(_ => this.store.dispatch(SelectedCartMarkerAction({ id })), 500);
    }

  }

  public showShareOrderPopup(): void {
    this.apteka = { ...this.apteka, showShareOrder: !this.apteka.showShareOrder };
  }

  public countCheck = (item: BzProduct) => item.isOrder;

  @AsyncCallback()
  private updateMap(markerID: number, value: boolean, coords?: [number, number]): void {
    this.store.dispatch(UpdateCartMarkerAction({ markerID, value }));

    if (value && coords) {
      this.toCurrentMap([coords[0], coords[1]], false, markerID);
    }
  }

}
